export default class NewsletterController {
  constructor(NewsletterDataProvider, $state) {
    "ngInject"
    this.NewsletterDataProvider = NewsletterDataProvider;
    this.$state = $state;
    let
      vm = this;
    vm.submitMsg = 0;
    NewsletterDataProvider.editor();
    vm.NewsletterDataProvider.getNewsletter('newsletter').then(function (result) {
      vm.newsletter = result;
      vm.setEditorsData();
    });
  }

  send(form) {
    if (!form) {
      return false;
    }
    let
      vm = this;
    vm.NewsletterDataProvider.sendNewsletter().then(function (res) {
      vm.submitMsg = 1;
    })
  }

  getEditorsData() {
    this.newsletter.data = tinyMCE.get('newsletter_text').getContent();
  }

  setEditorsData() {
    tinyMCE.get('newsletter_text').setContent(this.newsletter.data);
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/newsletter/components/send/controller.js
 **/